<script>
  import { Auth } from "./gauth";
  import YardMap from "./tabs/Quotes/YardMap.svelte";
  import QuoteDetails from "./tabs/QuoteDetails/QuoteDetails.svelte";
  import CreateJob from "./tabs/CreateJob/CreateJob.svelte";
  import JobsMap from "./tabs/Job/JobsMap.svelte";
  import Trucks from "./tabs/Trucks/Trucks.svelte";
  import { activeTab } from "./stores";
  import Settings from "carbon-icons-svelte/lib/Settings.svelte";
  import AdminModal from "./components/AdminModal.svelte";

  console.log(TT_WEB_API_URL);

  let signedIn = true;
  let showAdminModal = false;

  function loggedIn(e) {
    signedIn = true;
    console.dir(e);
  }

  function loggedOut(e) {
    signedIn = false;
    console.log("User logged out", e);
  }
</script>

<header class="app-header">
  <div class="brand-section">
    <div class="logo-wrapper">
      <img
        src="./assests/truck_east.png"
        alt="TruckTrack Logo"
        class="brand-logo"
      />
    </div>
    <div class="brand-text">
      <span class="brand-title">TruckTrack</span>
      <span class="brand-badge">Fleet Ops</span>
    </div>
  </div>

  <nav class="nav-tabs" aria-label="Main Navigation">
    <button
      class="nav-tab {$activeTab === 'quotes' ? 'active' : ''}"
      on:click={() => ($activeTab = 'quotes')}
      type="button"
    >
      <svg
        class="tab-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect x="4" y="2" width="16" height="20" rx="2" />
        <line x1="8" y1="6" x2="16" y2="6" />
        <line x1="16" y1="14" x2="16" y2="18" />
        <path d="M16 10h.01" />
        <path d="M12 10h.01" />
        <path d="M8 10h.01" />
        <path d="M12 14h.01" />
        <path d="M8 14h.01" />
        <path d="M12 18h.01" />
        <path d="M8 18h.01" />
      </svg>
      <span>Calculate</span>
    </button>

    <button
      class="nav-tab {$activeTab === 'quote-details' ? 'active' : ''}"
      on:click={() => ($activeTab = 'quote-details')}
      type="button"
    >
      <svg
        class="tab-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <line x1="10" y1="9" x2="8" y2="9" />
      </svg>
      <span>Quote Details</span>
    </button>

    <button
      class="nav-tab {$activeTab === 'create-job' ? 'active' : ''}"
      on:click={() => ($activeTab = 'create-job')}
      type="button"
    >
      <svg
        class="tab-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="12" y1="18" x2="12" y2="12" />
        <line x1="9" y1="15" x2="15" y2="15" />
      </svg>
      <span>Job Details</span>
    </button>

    <button
      class="nav-tab {$activeTab === 'jobs' ? 'active' : ''}"
      on:click={() => ($activeTab = 'jobs')}
      type="button"
    >
      <svg
        class="tab-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect x="1" y="3" width="15" height="13" />
        <polygon points="16 8 20 8 23 11 23 16 16 16 8" />
        <circle cx="5.5" cy="18.5" r="2.5" />
        <circle cx="18.5" cy="18.5" r="2.5" />
      </svg>
      <span>Fleet Tracking</span>
    </button>

    <button
      class="nav-tab {$activeTab === 'trucks' ? 'active' : ''}"
      on:click={() => ($activeTab = 'trucks')}
      type="button"
    >
      <svg
        class="tab-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
      </svg>
      <span>Reports</span>
    </button>
  </nav>

  <div class="header-right">
    <Auth
      on:auth-success={(e) => loggedIn(e)}
      on:auth-failed={(e) => loggedOut(e)}
    />
    <button
      type="button"
      class="header-settings-btn {showAdminModal ? 'active' : ''}"
      on:click={() => (showAdminModal = !showAdminModal)}
      title="Admin Settings & Environment"
      aria-label="Admin Settings"
    >
      <Settings size={18} />
    </button>
  </div>
</header>

{#if showAdminModal}
  <AdminModal on:close={() => (showAdminModal = false)} />
{/if}

{#if signedIn}
  <main class="app-main-window">
    {#if $activeTab === "quotes"}
      <YardMap lat={-33.81762602064655} lon={151.001900433117} zoom={10.5} />
    {/if}
    {#if $activeTab === "quote-details"}
      <QuoteDetails />
    {/if}
    {#if $activeTab === "create-job"}
      <CreateJob />
    {/if}
    {#if $activeTab === "jobs"}
      <JobsMap lat={-33.81762602064655} lon={151.001900433117} zoom={10.5} />
    {/if}
    {#if $activeTab === "trucks"}
      <Trucks />
    {/if}
  </main>
{/if}

<style>
  :global(body) {
    background-color: var(--tt-slate-100);
  }

  .app-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 56px;
    padding: 0 1.25rem;
    background-color: #ffffff;
    border-bottom: 1px solid var(--tt-slate-200);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
    position: relative;
    z-index: 2000;
  }

  .brand-section {
    display: flex;
    align-items: center;
    gap: 0.65rem;
  }

  .logo-wrapper {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .brand-logo {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .brand-text {
    display: flex;
    align-items: center;
    gap: 0.45rem;
  }

  .brand-title {
    font-size: 1.125rem;
    font-weight: 700;
    color: var(--tt-slate-900);
    letter-spacing: -0.025em;
  }

  .brand-badge {
    font-size: 0.6875rem;
    font-weight: 600;
    color: var(--tt-primary);
    background-color: var(--tt-primary-light);
    padding: 2px 7px;
    border-radius: 9999px;
    border: 1px solid var(--tt-primary-border);
    letter-spacing: 0.03em;
    text-transform: uppercase;
  }

  .nav-tabs {
    display: flex;
    align-items: center;
    background-color: var(--tt-slate-100);
    padding: 4px;
    border-radius: var(--tt-radius-md);
    border: 1px solid var(--tt-slate-200);
    gap: 2px;
  }

  .nav-tab {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    padding: 6px 14px;
    border-radius: var(--tt-radius-sm);
    font-size: 0.8125rem;
    font-weight: 500;
    color: var(--tt-slate-600);
    background: transparent;
    border: none;
    cursor: pointer;
    transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
    margin: 0;
  }

  .nav-tab:hover:not(.active) {
    color: var(--tt-slate-900);
    background-color: rgba(255, 255, 255, 0.6);
  }

  .nav-tab.active {
    background-color: #ffffff;
    color: var(--tt-primary);
    font-weight: 600;
    box-shadow:
      0 1px 3px rgba(0, 0, 0, 0.1),
      0 1px 2px rgba(0, 0, 0, 0.06);
  }

  .tab-icon {
    width: 15px;
    height: 15px;
    stroke-width: 2.25;
  }

  .header-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.65rem;
  }

  :global(.header-right > div button) {
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  :global(.header-right .google-auth) {
    height: 36px !important;
    border-radius: var(--tt-radius-sm) !important;
    padding: 0 10px 0 6px !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08) !important;
  }

  :global(.header-settings-btn) {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 36px !important;
    height: 36px !important;
    border-radius: var(--tt-radius-sm, 6px) !important;
    border: 1px solid var(--tt-slate-200, #cbd5e1) !important;
    background: #ffffff !important;
    color: var(--tt-slate-600, #475569) !important;
    cursor: pointer !important;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
    padding: 0 !important;
    margin: 0 !important;
    flex-shrink: 0 !important;
  }

  :global(.header-settings-btn:hover) {
    background: var(--tt-slate-50, #f8fafc) !important;
    color: var(--tt-primary, #0284c7) !important;
    border-color: var(--tt-primary, #0284c7) !important;
    transform: rotate(35deg);
    box-shadow: 0 2px 5px rgba(2, 132, 199, 0.15) !important;
  }

  :global(.header-settings-btn.active) {
    background: rgba(2, 132, 199, 0.1) !important;
    color: var(--tt-primary, #0284c7) !important;
    border-color: var(--tt-primary, #0284c7) !important;
    transform: rotate(45deg);
  }

  .app-main-window {
    position: relative;
    width: 100%;
    height: calc(100% - 56px);
    overflow: hidden;
  }

  @media (max-width: 768px) {
    .brand-badge {
      display: none;
    }
    .nav-tab span {
      display: none;
    }
    .nav-tab {
      padding: 6px 10px;
    }
  }
</style>
